<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg" [token]="token">

  <ng-container *ngIf="consulta">

    <h2 class="subtitle">DADOS</h2>
    <ul class="card-list-striped">
      <li><span class="text-secondary">Categoria: </span> <span>{{consulta?.categoria || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">CNH: </span> <span>{{consulta?.cnh || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">CPF: </span> <span>{{consulta?.cpf || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Data de nascimento: </span>
        <span>{{consulta?.dataNascimento || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Data primeira habilitação: </span>
        <span>{{consulta?.dataPrimeiraHabilitacao || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Data validade CNH: </span>
        <span>{{consulta?.dataValidadeCnh || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">ID Passagem: </span> <span>{{consulta?.idPassagem || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Municipio: </span> <span>{{consulta?.municipio || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Nome: </span> <span>{{consulta?.nome || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Nome da mãe: </span> <span>{{consulta?.nomeMae || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Nome do pai: </span> <span>{{consulta?.nomePai || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Observações: </span> <span>{{consulta?.observacao || "NÃO INFORMADO"}}</span></li>
    </ul>

    <div ng-show="consulta?.pontuacao">
      <h2 class="subtitle">PONTUAÇÃO</h2>
      <div>
        <ul class="card-list-striped pb-3">
          <li>
            <span class="text-secondary">Cpf:</span>
            <span>{{ pontuacao?.Cpf || 'NÃO INFORMADO' }}</span>
          </li>
          <li>
            <span class="text-secondary">Impedimentos:</span>
            <span>{{ pontuacao?.impedimenetos || 'NÃO INFORMADO' }}</span>
          </li>
          <li>
            <span class="text-secondary">Portaria:</span>
            <span>{{ pontuacao?.portaria || 'NÃO INFORMADO' }}</span>
          </li>
          <li>
            <span class="text-secondary">Registro:</span>
            <span>{{ pontuacao?.registros || 'NÃO INFORMADO' }}</span>
          </li>
          <li>
            <span class="text-secondary">Pontuação:</span>
            <span>{{ pontuacao?.pontuacao || 'NÃO INFORMADO' }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div ng-show="consulta?.registrosBloqueio">
      <h2 class="subtitle">REGISTROS DE BLOQUEIO</h2>

      <div *ngIf="registrosBloqueados.length > 0">
        <ul class="card-list-striped" *ngFor="let r of registrosBloqueados">
          <li>
            <span class="text-secondary">Descrição:</span>
            <span>{{ r.descricaoBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Requisitos de Liberação:</span>
            <span>{{ r.requisitosLiberacao || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Data:</span>
            <span>{{ r.dataBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Tipo de Decisão:</span>
            <span>{{ r.tipoDecisaoBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Orgão Responsável:</span>
            <span>{{ r.orgaoResponsavelBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Motivo:</span>
            <span>{{ r.motivoBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Recolhimento da Cnh:</span>
            <span>{{ r.recolhimentoCnh || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Data do Início da Penalidade:</span>
            <span>{{ r.dataInicioPenalidadeBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">UF Detran:</span>
            <span>{{ r.ufDetranBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Prazo da Penalidade Total:</span>
            <span>{{ r.prazoPenalidadeTotal || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Tipo Atualização:</span>
            <span>{{ r.tipoAtualizacao || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Prazo da Penalidade:</span>
            <span>{{ r.prazoPenalidade || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Data Fim da Penalidade:</span>
            <span>{{ r.dataFimPenalidadeBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Documento Gerador Bloqueio:</span>
            <span>{{ r.documentoGeradorBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
        </ul>
      </div>

      <div class="card-msg d-flex flex-column flex-md-row" *ngIf="registrosBloqueados.length == 0">
        <span class="text-center">NENHUM REGISTRO LOCALIZADO</span>
      </div>
    </div>

    <div ng-show="consulta?.registrosBloqueioLiberacao">
      <h2 class="subtitle">REGISTROS DE BLOQUEIO E LIBERAÇÃO</h2>

      <div *ngIf="registrosBloqueadosLiberacao.length > 0">
        <ul class="card-list-striped" *ngFor="let r of registrosBloqueadosLiberacao">
          <li>
            <span class="text-secondary">UF Detran bloqueio:</span>
            <span>{{ r.ufDetranBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Motivo bloqueio:</span>
            <span>{{ r.motivoBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Data bloqueio:</span>
            <span>{{ r.dataBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Orgão responsável bloqueio:</span>
            <span>{{ r.orgaoResponsavelBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Documento gerador bloqueio:</span>
            <span>{{ r.documentoGeradorBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Descrição bloqueio:</span>
            <span>{{ r.descricaoBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Tipo decisão bloqueio:</span>
            <span>{{ r.tipoDecisaoBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Recolhimento CNH:</span>
            <span>{{ r.recolhimentoCnh || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Requisitos liberação:</span>
            <span>{{ r.requisitosLiberacao || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Prazo penalidade:</span>
            <span>{{ r.prazoPenalidade || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Prazo penalidade total:</span>
            <span>{{ r.prazoPenalidadeTotal || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Data início penalidade bloqueio:</span>
            <span>{{ r.dataInicioBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Data fim penalidade bloqueio:</span>
            <span>{{ r.dataFimBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">UF Detran liberação bloqueio:</span>
            <span>{{ r.ufDetranLiberacaoBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Data liberação bloqueio:</span>
            <span>{{ r.dataLiberacaoBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Motivo liberação bloqueio:</span>
            <span>{{ r.motivoLiberacaoBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Orgao responsável liberação bloqueio:</span>
            <span>{{ r.orgaoResponsavelLiberacaoBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Documento gerador liberação bloqueio:</span>
            <span>{{ r.documentoGeradorLiberacaoBloqueio || 'NÃO INFORMADO'}}</span>
          </li>
        </ul>
      </div>

      <div class="card-msg d-flex flex-column flex-md-row" *ngIf="registrosBloqueadosLiberacao.length == 0">
        <span class="text-center">NENHUM REGISTRO LOCALIZADO</span>
      </div>

    </div>

    <div ng-show="consulta?.registrosCursos">
      <h2 class="subtitle">REGISTROS DE CURSOS</h2>

      <div *ngIf="cursos.length > 0">
        <ul class="card-list-striped" *ngFor="let c of cursos">
          <li>
            <span class="text-secondary">Curso:</span>
            <span>{{ c.curso || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Tipo:</span>
            <span>{{ c.tipoAtualizacao || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Modalidade:</span>
            <span>{{ c.modalidade || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Número certificado:</span>
            <span>{{ c.numeroCertificado || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Data inicio do curso:</span>
            <span>{{ c.dataInicioCurso || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Data fim do curso:</span>
            <span>{{ c.dataFimCurso || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Carga horária:</span>
            <span>{{ c.cargaHoraria || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">CNPJ entidade credenciada:</span>
            <span>{{ c.cnpjEntidadeCredenciada || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">CPF profissional:</span>
            <span>{{ c.cpfProfissional || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Município do curso:</span>
            <span>{{ c.municipioCurso || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">UF do curso:</span>
            <span>{{ c.ufCurso || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Data de validade:</span>
            <span>{{ c.dataValidade || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Categoria:</span>
            <span>{{ c.categoria || 'NÃO INFORMADO'}}</span>
          </li>
        </ul>
      </div>

      <div class="card-msg d-flex flex-column flex-md-row" *ngIf="cursos.length == 0">
        <span class="text-center">NENHUM REGISTRO LOCALIZADO</span>
      </div>
    </div>

    <div ng-show="consulta?.registrosExames">
      <h2 class="subtitle">REGISTROS DE EXAMES</h2>

      <div *ngIf="exames.length > 0">
        <ul class="card-list-striped pb-3 " *ngFor="let e of exames">
          <li>
            <span class="text-secondary">Exame:</span>
            <span>{{ e.exame || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Tipo:</span>
            <span>{{ e.tipoAtualizacao || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Data do exame:</span>
            <span>{{ e.dataExame || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Resultado:</span>
            <span>{{ e.resultado || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Data de validade:</span>
            <span>{{ e.dataValidade || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">CPF Profissional 1:</span>
            <span>{{ e.cpfProfissional1 || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">CPF Profissional 2:</span>
            <span>{{ e.cpfProfissional2 || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">CNPJ entidade credenciada:</span>
            <span>{{ e.cnpjEntidadeCredenciada || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Município do exame:</span>
            <span>{{ e.municipioExame || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">UF do exame:</span>
            <span>{{ e.ufExame || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Categoria pretendida:</span>
            <span>{{ e.categoriaPretendida || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Categoria permitida:</span>
            <span>{{ e.categoriaPermitida || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Observações:</span>
            <span>{{ e.observacoes || 'NÃO INFORMADO'}}</span>
          </li>
          <li>
            <span class="text-secondary">Restrições:</span>
            <span>{{ e.restricoesTexto || 'NÃO INFORMADO'}}</span>
          </li>
        </ul>
      </div>

      <div class="card-msg d-flex flex-column flex-md-row" *ngIf="exames.length == 0">
        <span class="text-center">NENHUM REGISTRO LOCALIZADO</span>
      </div>

    </div>

    <div ng-show="consulta?.Observacoes">
      <h2 class="subtitle">OBSERVAÇÕES</h2>

      <div *ngIf="observacoes.length > 0">
        <ul class="card-list-striped pb-3 " *ngFor="let o of observacoes">
          <li>
            <span class="text-secondary">Observação:</span>
            <span>{{ o.observacao || 'NÃO INFORMADO'}}</span>
          </li>
        </ul>
      </div>

      <div class="card-msg d-flex flex-column flex-md-row" *ngIf="observacoes.length == 0">
        <span class="text-center">NENHUM REGISTRO LOCALIZADO</span>
      </div>

    </div>

  </ng-container>

</app-card-consulta>
